<template>
  <div class="result-viewer">
    <div class="loading-screen" v-if="!isLoadedData">
      <div class="spinner">
        <br />
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
    </div>
    <div v-if="isLoadedData">
      <div class="row">
        <div class="header-bar col-md-12">
          <div class="row">
            <div class="col-md-2 hidden-sm-and-down" style="margin-top: 10px; margin-bottom: 10px">
            </div>
            <div class="col-md-7">
              <div style="margin-top: 10px; color: darkslategray" class="text-center">
                <!--{{documentInfo.title}}-->
                <truncate
                  v-if="documentInfo.title"
                  clamp="..."
                  :length="50"
                  :text="documentInfo.title"
                  class="document-title"
                  :title="documentInfo.title"
                />
                <!--:text="'<span style=&quot;font-size: 20px; font-weight: 600&quot;>' + documentInfo.title + '</span>'"-->
              </div>
              <div style="font-size: 14px; color: darkslategray" class="text-center">
                Tác giả:
                <span class="bold">{{ documentInfo.ownerName }}</span>
                <span class="margin-right-15 margin-left-15">|</span> Thời gian tải lên:
                <span class="bold">{{ formatUploadTime(documentInfo.uploadTime) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 hidden-sm-and-down">
          <div class="max_height_exclude_title local-scroller" id="preview-result" @scroll="loadMorePreview">
            <div
              v-for="(data_page, index) in dataCombinePagesCurrent"
              :key="data_page.pageId"
              :id="'page-preview-' + data_page['pageId']"
            >
              <PreviewResult
                :is-loaded="startedLoadingState[index].isLoaded || previewStartedLoadingState[index].isLoaded"
                :data_page="data_page"
                :index="index + 1"
              />
            </div>
          </div>
        </div>
        <div class="col-md-7">
          <!--                    Display current page number-->
<!--          <div class="page-number">-->
<!--            <div>{{ currentPage }} / {{ dataCombinePagesCurrent.length }}</div>-->
<!--          </div>-->

          <!--                    <div class="max_height_exclude_title local-scroller" onmouseover="this.style.overflow='scroll'" onmouseout="this.style.overflow='hidden'">-->
          <div :class="['max_height_exclude_title', 'local-scroller']" id="page-result" @scroll="SyncScrollPageResult">
            <div
              v-for="(data_page, index) in dataCombinePagesCurrent"
              :key="data_page.pageId"
              :id="'page-' + data_page.pageId + '-container'"
              style="position: relative"
            >
              <PageResultShowing
                :document_type="'document'"
                :data_page="data_page"
                :index="index + 1"
                :isStartedLoading="startedLoadingState[index].isLoaded"
                @reload-group="reloadGroup($event)"
                @click-result="updateCardListPosition($event)"
              />
            </div>
          </div>
        </div>
        <div class="col-md-3 hidden-sm-and-down" style="padding-right: 5px">
          <!--Right bar's header -->
          <div class="right-col-header margin-top-5 margin-bottom-5 padding-top-15 padding-bottom-15">
            <!--Plagiarism Mode-->
            <div v-if="currentMode === ResultViewMode.PLAGIARISM" class="margin-left-15" style="font-size: 20px">
              <span>Tương đồng: </span>&ensp;
              <span style="font-size: 28px">{{ currentScore !== -1 ? currentScore : 0 }} %</span>
              <span style="float: right; margin-right: 15px; display: flex; flex-direction: row">
                <SourcesManager
                  :blocked-data="usingVersion.ignoredSimilarSources"
                  @updateSource="updateExcludeLinkList($event)"
                ></SourcesManager>
                <FilterForm @submit="handleFilter($event)"></FilterForm>
              </span>
            </div>

            <!--Spelling Mode-->
            <div v-else-if="currentMode === ResultViewMode.SPELL" class="margin-left-15" style="font-size: 20px">
              <span> Lỗi chính tả</span>
            </div>
          </div>
          <!--                    <div class="local-scroller padding-right-5 max-height-card-col card-col" onmouseover="this.style.overflow='scroll'"  onmouseout="this.style.overflow='hidden'">-->
          <div class="max-height-card-col">
            <div v-if="currentMode === ResultViewMode.PLAGIARISM" class="card-list-container">
              <PlagiarismCardList
                ref="cardList"
                :data="currentSimilarityGroups"
                :version="usingVersion"
                @exclude-link-list="updateExcludeLinkList($event)"
              ></PlagiarismCardList>
            </div>
            <div v-else-if="currentMode === ResultViewMode.SPELL" class="card-list-container">
              <SpellErrorList></SpellErrorList>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  apiGetCurrentGroupVersion,
  apiGetGroupImageResult,
  apiGetGroupSimilarities,
  apiGetGroupSimilarityData,
  getLevelPlagiarism,
} from '@/services/doit_result_service'
import _ from 'lodash'
import { apiGetGroupDocumentInfo } from '@/services/document_management_service'
import { combineDataPerPage, transformPlagiarismPerPage } from '@/services/doit_transform_data'
import moment from 'moment'
import truncate from 'vue-truncate-collapsed'
import PreviewResult from '@/components/ResultDocument/PreviewResult'
import PageResultShowing from '@/components/ResultDocument/PageResultShowing'
import { getSimilarityGroups } from '@/services/similarities_result_service'
import {
  PlagScoreType,
  reloadGroupType,
  ResultViewMode,
  SortPlagMode,
  SourceIgnoredReasons,
} from '@/constants/DoITConstant'
import SpellErrorList from '@/components/ResultDocument/SpellErrorList'
import PlagiarismCardList from '@/components/ResultDocument/PlagiarismCardList'
import FilterForm from '@/components/ResultDocument/FilterForm'
import SourcesManager from '@/components/ResultDocument/SourcesManager'
import { apiGetConfigDocumentScore } from '@/services/doit_config_service'

export default {
  name: 'ResultGroupDocumentPage',
  props: {
    slug: {
      type: String,
    },
  },
  components: {
    FilterForm,
    PlagiarismCardList,
    PageResultShowing,
    PreviewResult,
    truncate,
    SpellErrorList,
    SourcesManager,
  },
  data: () => {
    return {
      ResultViewMode,
      documentInfo: {},
      isLoadedData: false,
      currentVersion: {},
      usingVersion: {},
      currentSimilarityGroups: [],
      dataImages: [],
      currentMode: 'plagiarismMode',
      startedLoadingState: [],
      previewStartedLoadingState: [],
      currentPage: '1',
      prevPosition: 0,
      totalLength: -1,
      dataCombinePagesCurrent: {},
      filterOptions: {
        sortPlagModeType: SortPlagMode.SEQUENCE,
        filterPlagScoresType: [PlagScoreType.HIGH, PlagScoreType.MEDIUM, PlagScoreType.LOW],
        filterPlagSystemIgnore: true,
        filterPlagUserIgnore: true,
      },
      tempIgnoredSource: [],
    }
  },
  mounted() {
    this.$store.dispatch('docRes/updateDocumentResultMode', 'plagiarismMode')
    let t1 = performance.now()

    // Fetch result data
    Promise.all([
      apiGetGroupSimilarities(this.slug),
      apiGetGroupSimilarityData(this.slug),
      apiGetCurrentGroupVersion(this.slug),
      apiGetGroupDocumentInfo(this.slug),
      apiGetGroupImageResult(this.slug),
      apiGetConfigDocumentScore(),
    ]).then(async (result) => {
      console.log('Loaded data: ', performance.now() - t1)
      this.$store.dispatch('docRes/plagiarism/updateConfigDocumentScore', result[5])

      this.documentInfo = result[3]

      const similarities = _.keyBy(result[0].similarities, (s) => s.similarityId)
      // Push similarities -> Vuex
      this.$store.dispatch('docRes/plagiarism/updateSimilarities', similarities)

      // {sentences: Array(4040), similarSentences: Array(13910), similarSources: Array(3233), totalLength: 854316}
      const similarityData = result[1]
      this.updateSimilarityData(similarityData)

      // Update Document's info
      this.$store.dispatch('docRes/updateDocumentInfoCurrent', {
        ...result[3],
        slug: this.slug,
        totalLength: similarityData.totalLength,
      })
      this.totalLength = similarityData.totalLength

      this.dataImages = result[4]

      this.currentVersion = result[2]
      console.log('current version: ', this.currentVersion)

      this.usingVersion = JSON.parse(JSON.stringify(this.currentVersion))
      this.applyVersion()

      const numberOfPages = this.dataCombinePagesCurrent.length
      for (let i = 0; i < numberOfPages; i++) {
        if (i < 10) {
          this.startedLoadingState.push({ pageId: i + 1, isLoaded: true })
          this.previewStartedLoadingState.push({ pageId: i + 1, isLoaded: true })
        } else {
          this.startedLoadingState.push({ pageId: i + 1, isLoaded: false })
          this.previewStartedLoadingState.push({ pageId: i + 1, isLoaded: false })
        }
      }

      this.isLoadedData = true
    })
  },
  methods: {
    updateCardListPosition(index) {
      this.$refs.cardList.scrollToItem(index)
    },
    handleFilter({ sortPlagModeType, filterPlagScoresType, filterPlagSystemIgnore, filterPlagUserIgnore }) {
      this.filterOptions.sortPlagModeType = sortPlagModeType
      this.filterOptions.filterPlagScoresType = filterPlagScoresType
      this.filterOptions.filterPlagSystemIgnore = filterPlagSystemIgnore
      this.filterOptions.filterPlagUserIgnore = filterPlagUserIgnore
      this.applyVersion()
    },
    updateSimilarityData(similarityData) {
      // Push similarity sources -> Vuex
      let similarSources = _.keyBy(similarityData.similarSources, (source) => source.id)
      this.$store.dispatch('docRes/plagiarism/updateSimilarSources', similarSources)

      // Push similarity sentence -> Vuex
      let similarSentences = _.keyBy(similarityData.similarSentences, (sen) => sen.id)
      this.$store.dispatch('docRes/plagiarism/updateSimilarSentences', similarSentences)

      // Push source sentence -> Vuex
      let sourceSentences = _.keyBy(similarityData.sentences, (sen) => sen.sentenceId)
      this.$store.dispatch('docRes/plagiarism/updateSourceSentences', sourceSentences)
    },
    updateExcludeLinkList({ domains, sourceIds }) {
      console.log('excluded: ', domains, sourceIds)

      if (domains.length > 0) {
        domains.forEach((domain) => {
          const sources = this.similarSources[domain]
          sources.forEach((source) => sourceIds.push(source.id))
        })
      }
      sourceIds.forEach((sourceId) => {
        const index = this.tempIgnoredSource.findIndex((tempSource) => tempSource === sourceId)
        if (index === -1) {
          this.tempIgnoredSource.push(sourceId)
        } else {
          this.tempIgnoredSource.splice(index, 1)
        }
      })
      this.reloadGroup({ type: reloadGroupType.IGNORE_SOURCE })
    },
    applyVersion() {
      this.currentSimilarityGroups = JSON.parse(JSON.stringify(this.usingVersion.similarities))
      this.applyIgnoredSentences()
      this.applyFilter()
      this.addGroupInformation()
      // this.$store.dispatch('docRes/plagiarism/updateSimilarityGroups', this.currentSimilarityGroups)
      this.processData()
    },
    applyFilter() {
      this.currentSimilarityGroups = this.currentSimilarityGroups.filter((group) => {
        const isIgnored = group.isIgnored
        const isIgnoredBySystem = group.isIgnoredBySystem
        const filterScore = this.filterOptions.filterPlagScoresType
        if (
          !isIgnored &&
          !isIgnoredBySystem &&
          filterScore.indexOf(getLevelPlagiarism(group.score, this.configDocumentScore)) === -1
        ) {
          return false
        }
        if (isIgnored && !this.filterOptions.filterPlagUserIgnore) {
          return false
        }
        if (isIgnoredBySystem && !this.filterOptions.filterPlagSystemIgnore) {
          return false
        }
        return true
      })

      let sortFunction = (a, b) => {
        return a.parts[0].startWordId - b.parts[0].startWordId
      }
      if (this.filterOptions.sortPlagModeType === SortPlagMode.SCORE_ASC) {
        sortFunction = (a, b) => {
          return a.score - b.score
        }
      } else if (this.filterOptions.sortPlagModeType === SortPlagMode.SCORE_DESC) {
        sortFunction = (a, b) => {
          return b.score - a.score
        }
      }
      this.currentSimilarityGroups.sort(sortFunction)
      this.currentSimilarityGroups.forEach((group) => {
        group.parts.sort((a, b) => {
          return a.startWordId - b.startWordId
        })
      })
    },
    addGroupInformation() {
      for (let i in this.currentSimilarityGroups) {
        this.currentSimilarityGroups[i]['id'] = parseInt(i) + 1
        if (!this.currentSimilarityGroups[i].isIgnored) {
          this.currentSimilarityGroups[i]['isIgnored'] = false
          this.currentSimilarityGroups[i]['ignoredReason'] = ''
          if (!this.currentSimilarityGroups[i].isIgnoredBySystem) {
            this.currentSimilarityGroups[i]['isIgnoredBySystem'] = false
            this.currentSimilarityGroups[i]['ignoredBySystemReason'] = ''
          }
        } else {
          this.currentSimilarityGroups[i]['isIgnoredBySystem'] = false
          this.currentSimilarityGroups[i]['ignoredBySystemReason'] = ''
        }
      }
    },
    reloadGroup(data) {
      this.isLoadedData = false
      // let timeout = setTimeout(() => {
      //     _isLoadedData_ = false
      // }, 1000)

      console.info('Reloading group')
      const ignoredSentences = this.getIgnoredSentences()
      const ignoredSources = this.getIgnoredSources()
      const { similarities, sentenceIds } = this.getReloadSimilarities(data)
      // TODO: Add ignoredSourceList parameter after implementing source manager
      const mergedIgnoredSentences = JSON.parse(JSON.stringify(ignoredSentences))
      for (let ignoredSentence of this.usingVersion.ignoredBySystemSentences) {
        mergedIgnoredSentences.push({
          ignoreReason: ignoredSentence.ignoreReason,
          sentenceIds: ignoredSentence.sentenceId,
        })
      }

      const newGroupPart = getSimilarityGroups(similarities, ignoredSources, mergedIgnoredSentences)

      let newGroupSimilarities = []
      if (sentenceIds !== null) {
        if (sentenceIds.length > 0) {
          const _similarities = this.similarities
          newGroupSimilarities = this.usingVersion.similarities.filter((simi) => {
            const similarityId = simi.parts[0].similarityId
            const similarity = _similarities[similarityId]
            return similarity && sentenceIds.indexOf(similarity.sentenceId) === -1
          })
        } else {
          newGroupSimilarities = this.usingVersion.similarities
        }
      }
      newGroupSimilarities.push(...newGroupPart)

      const version = {
        ignoredBySystemSentences: this.usingVersion.ignoredBySystemSentences,
        ignoredSentences: ignoredSentences,
        ignoredSimilarSources: ignoredSources,
        similarities: newGroupSimilarities,
      }
      this.usingVersion = version
      this.applyVersion()
      // clearTimeout(timeout)
      this.isLoadedData = true
    },
    getReloadSimilarities(data) {
      let sentenceIds = []
      let res = []
      const similaritiesArr = Object.values(this.similarities)
      const getSentenceIds = (index) => {
        const group = this.currentSimilarityGroups[index - 1]
        let ids = []
        if (group) {
          for (let part of group.parts) {
            if (part.sentenceId) {
              ids.push(part.sentenceId)
            } else {
              const similarity = this.similarities[part.similarityId]
              ids.push(similarity.sentenceId)
            }
          }
        }
        return ids
      }
      if (data.type === reloadGroupType.IGNORE_SENTENCE) {
        sentenceIds = getSentenceIds(data.groupId)
      } else if (data.type === reloadGroupType.ENABLE_SENTENCE || data.type === reloadGroupType.UNDO_ACTION) {
        for (let i = data.groupId - 1; i <= data.groupId + 1; i++) {
          sentenceIds.push(...getSentenceIds(i))
        }
        res = similaritiesArr.filter((similar) => sentenceIds.indexOf(similar.sentenceId) !== -1)
      } else {
        res = similaritiesArr
        sentenceIds = null
      }
      return { similarities: res, sentenceIds }
    },
    getIgnoredSentences() {
      let ignoredSentences = JSON.parse(JSON.stringify(this.currentVersion.ignoredSentences))
      this.lstResultPlagIgnoredCurrent.forEach((ignoringPla) => {
        if (!ignoringPla.isIgnored) {
          let plaIndex = ignoredSentences.findIndex((ignoredPla) =>
            _.isEqual(_.sortBy(ignoredPla.sentenceIds), _.sortBy(ignoringPla.sentenceIds))
          )
          if (plaIndex !== -1) {
            ignoredSentences.splice(plaIndex, 1)
          }
        } else {
          ignoredSentences.push({
            ignoreReason: ignoringPla.reasonIgnoreType || ignoringPla.reason,
            sentenceIds: ignoringPla.sentenceIds,
          })
        }
      })
      return ignoredSentences
    },
    getIgnoredSources() {
      let ignoredSources = JSON.parse(JSON.stringify(this.currentVersion.ignoredSimilarSources))
      this.tempIgnoredSource.forEach((ignoredSource) => {
        const index = ignoredSources.findIndex((source) => source.targetId === ignoredSource)
        if (index === -1) {
          ignoredSources.push({ targetId: ignoredSource, ignoreReason: SourceIgnoredReasons.OTHER })
        } else {
          ignoredSources.splice(index, 1)
        }
      })
      return ignoredSources
    },
    applyIgnoredSentences() {
      this.usingVersion.ignoredSentences.forEach((ignoredSentence) => {
        let newGroup = { isIgnored: true, ignoredReason: ignoredSentence.ignoreReason, parts: [] }
        ignoredSentence.sentenceIds.forEach((id) => newGroup.parts.push(this.sourceSentences[id]))
        this.currentSimilarityGroups.push(newGroup)
      })
      this.usingVersion.ignoredBySystemSentences.forEach((ignoredSentence) => {
        let newGroup = { isIgnoredBySystem: true, ignoredBySystemReason: ignoredSentence.ignoreReason, parts: [] }
        newGroup.parts.push(this.sourceSentences[ignoredSentence.sentenceId])
        this.currentSimilarityGroups.push(newGroup)
      })
    },
    processData() {
      let st = performance.now()
      const dataPlagiarismSplitPerPage = transformPlagiarismPerPage(this.currentSimilarityGroups)
      const dataCombinePages = combineDataPerPage(this.dataImages, dataPlagiarismSplitPerPage, [])
      this.dataCombinePagesCurrent = dataCombinePages

      console.info('Process Data: ', performance.now() - st)
    },
    formatUploadTime(uploadTime) {
      return moment(uploadTime).format('HH:mm DD/MM/YY')
    },
    loadMorePreview() {
      let currentPreviewPage = this.getCurrentPreviewPage()
      for (let i = 0; i < 5; i++) {
        if (this.previewStartedLoadingState[currentPreviewPage + i]) {
          this.previewStartedLoadingState[currentPreviewPage + i].isLoaded = true
        }
      }
    },
    SyncScrollPageResult(e) {
      const pageResult = e.target
      const div1 = document.getElementById('preview-result')
      div1.scrollTop = div1.scrollHeight * (pageResult.scrollTop / pageResult.scrollHeight) - div1.offsetHeight / 4

      let pageResultScrollTop = pageResult.scrollTop
      if (Math.abs(pageResultScrollTop - this.prevPosition) >= this.pageResultHeight() / 2) {
        this.getCurrentPage()
        this.prevPosition = pageResultScrollTop
      }
    },
    pageResultHeight() {
      let elem = document.querySelector('#page-result')
      return elem == null ? null : elem.clientHeight
    },
    getCurrentPage() {
      let result = '-'

      for (let i = 1; i <= this.dataCombinePagesCurrent.length; i++) {
        let element = document.querySelector('#page-' + i + '-container')
        if (element == null) break
        let elemInfo = element.getBoundingClientRect()
        if (elemInfo.top + elemInfo.bottom >= 0) {
          result = i.toString()
          break
        }
      }

      this.currentPage = result
    },
    getCurrentPreviewPage() {
      let result = '-'

      for (let i = 1; i <= this.dataCombinePagesCurrent.length; i++) {
        let element = document.querySelector('#page-preview-' + i)
        if (element == null) break
        let elemInfo = element.getBoundingClientRect()
        if (elemInfo.top + elemInfo.bottom >= 0) {
          result = i
          break
        }
      }
      return result
    },
  },
  computed: {
    configDocumentScore() {
      return this.$store.getters['docRes/plagiarism/getConfigDocumentScore']
    },
    sourceSentences() {
      return this.$store.getters['docRes/plagiarism/getAllSourceSentences']
    },
    similarities() {
      return this.$store.getters['docRes/plagiarism/getAllSimilarities']
    },
    lstResultPlagIgnoredCurrent() {
      return this.$store.getters['docRes/plagiarism/lstResultPlagIgnoredCurrent']
    },
    currentScore() {
      let res = 0
      for (let elem of this.currentSimilarityGroups) {
        // Apply ignored by user
        if (!elem.isIgnored && !elem.isIgnoredBySystem) {
          res += elem.score * elem.length
        }
      }
      if (this.totalLength === -1) return null
      res = res / this.totalLength
      if (res > 0 && res < 1) return '<1'
      return Math.floor(res)
    },
    similarSources() {
      const sources = Object.values(this.$store.getters['docRes/plagiarism/getAllSimilarSources'])
      return _.groupBy(sources, (source) => source.domain)
    },
  },
  watch: {
    currentPage: function (newValue) {
      let currentPage = parseInt(newValue)
      for (let i = -2; i <= 2; i++) {
        if (
          this.startedLoadingState[currentPage + i] !== undefined &&
          this.startedLoadingState[currentPage + i].isLoaded === false
        ) {
          this.startedLoadingState[currentPage + i].isLoaded = true
        }
      }
    },
  },
}
</script>

<style lang="scss">
#progress-container-el {
  /* background */
  background-color: #f4f4f4 !important;
}

#progress-el {
  /* progress bar */
  background-color: red !important;
}

.card-list-container {
  height: 100%;
}

.max-height-card-col {
  height: calc(100vh - 85px - 82px);
}

.max_height_exclude_title {
  height: calc(100vh - 85px);
}

.max_height_after_change {
  height: calc(100vh - 85px - 40px);
}

.update-ignore-bnt {
  position: fixed;
  bottom: 30px;
  right: 30%;
  background: #c9d9e4;
  z-index: 1;
  width: 208pt;
  height: 35pt;
}

.submit-user-change-div {
  background-color: #3d5396;
  height: 40px;
  width: 100%;
}

.submit-user-change-div div.col {
  color: white;
  font-size: 14px;
  font-weight: 600;
}

.submit-user-change-div div.col button {
  border: 1px solid #fff;
  padding: 8px;
  background-color: whitesmoke;
}

.submit-user-change-div div.col button span {
  color: #3d5396;
}

.submit-user-change-div div.colon .el-icon-check {
  color: #ffffff;
}

.document-title span {
  font-size: 24px;
  font-weight: 600;
}

.spinner {
  margin: 200px auto;
  width: 500px;
  height: 100px;
  text-align: center;
  font-size: 10px;
}

.spinner > div {
  background-color: #3d5396;
  height: 100%;
  width: 15px;
  margin-right: 3px;
  display: inline-block;

  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.spinner .rect3 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

.spinner .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.spinner .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

@-webkit-keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    -webkit-transform: scaleY(0.4);
  }
  20% {
    -webkit-transform: scaleY(1);
  }
}

@keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
    -webkit-transform: scaleY(1);
  }
}

.header-bar {
  height: 80px;
  background-color: #ffffff;
  padding: 3px 15px 5px 15px;
  border-bottom: 1px solid lightgray;
  z-index: 1500;
}

.right-col-header {
  background-color: #3d5396;
  color: white;
  font-size: 28px;
}

.el-radio-button__inner {
  font-weight: 600 !important;
}

.page-number {
  position: absolute;
  background-color: rgba(57, 57, 57, 0.8);
  border-radius: 4px;
  margin: auto;
  left: 0;
  right: 0;
  bottom: 5px;
  min-width: 50px;
  max-width: 70px;
  z-index: 1500;
  text-align: center;
  height: 30px;
}

.page-number div {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  min-height: 20px;
  color: #fff;
  font-weight: 600;
}

.item div {
  padding: 2px 5px;
}

.item-date span {
  font-size: 1.2rem;
  font-weight: 600;
}

.loading-screen {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99999 !important;
  width: 100%;
  height: 100%;
  background: white;
  text-align: center;
}

.change-mode-btn .el-radio-group .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #3d5396;
  border-color: #3d5396;
}
</style>
